import { RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_CHANGE_PASSWORD_REQUEST,
  FETCH_CHANGE_PASSWORD_SUCCESS,
  FETCH_CHANGE_PASSWORD_FAILURE,
  FETCH_CHANGE_PASSWORD_AUTH_FAILURE,
  FETCH_CHANGE_PASSWORD_AUTH_SUCCESS,
  FETCH_CHANGE_PASSWORD_AUTH_REQUEST,
  SET_CHANGE_PASSWORD_STORE,
  RESET_CHANGE_PASSWORD_STORE,
} from "./actions.type";
import {
  FetchChangePasswordRequest,
  FetchChangePasswordSuccess,
  FetchChangePasswordFailure,
  FetchChangePasswordAuthRequest,
  FetchChangePasswordAuthSuccess,
  FetchChangePasswordAuthFailure,
  FormChangePasswordData,
  ChangePasswordState,
  SetStoreChangePassword,
  ResetStoreChangePassword,
} from "./types";

export const fetchChangePasswordRequest = (payload?: FormChangePasswordData): FetchChangePasswordRequest => ({
  type: FETCH_CHANGE_PASSWORD_REQUEST,
  payload,
});

export const fetchChangePasswordSuccess = (payload?: RESPONSEDATA): FetchChangePasswordSuccess => ({
  type: FETCH_CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const fetchChangePasswordFailure = (payload?: string): FetchChangePasswordFailure => ({
  type: FETCH_CHANGE_PASSWORD_FAILURE,
  payload,
});

export const fetchChangePasswordAuthRequest = (payload?: RESPONSEDATA, code?: string): FetchChangePasswordAuthRequest => ({
  type: FETCH_CHANGE_PASSWORD_AUTH_REQUEST,
  payload,
  code,
});

export const fetchChangePasswordAuthSuccess = (payload?: RESPONSEDATA): FetchChangePasswordAuthSuccess => ({
  type: FETCH_CHANGE_PASSWORD_AUTH_SUCCESS,
  payload,
});

export const fetchChangePasswordAuthFailure = (errorOTP: boolean, payload?: string): FetchChangePasswordAuthFailure => ({
  type: FETCH_CHANGE_PASSWORD_AUTH_FAILURE,
  errorOTP,
  payload,
});

export const setStoreChangePassword = (payload?: ChangePasswordState): SetStoreChangePassword => ({
  type: SET_CHANGE_PASSWORD_STORE,
  payload,
});

export const resetStoreChangePassword = (): ResetStoreChangePassword => ({
  type: RESET_CHANGE_PASSWORD_STORE,
});
